/**
 * Accessibility patch for the Dash Social UGC carousel ("Lived In Since 1883"
 * / "Styled by you"). Merch embeds it in a Custom HTML section
 * (sections/clean-html.liquid, content in templates/*.json) with
 * cdn.dashsocial.com/web/js/board-carousel-embed.js, which renders a slick
 * carousel into `.dh-widget-container`.
 *
 * Its slick track is `div.slick-track[role="list"]` and every slide is a
 * `div[role="listitem"]`. The 6 X 2026 SortSite scan flagged the track on
 * 1064 pages: "role=list ... must not contain elements with other roles",
 * owned roles image/figure/button (W3cHtml5AriaRequiredChildRole-list,
 * WCAG 1.3.1, Level A). A row of photos with "Learn More" buttons doesn't
 * need list semantics, so we drop both roles (a listitem outside a list would
 * be its own error). Slick may set them again when it re-initialises, so a
 * MutationObserver on the section re-applies the patch. Writes happen only
 * when a role is present, so it settles.
 */

const EMBED_SCRIPT_SELECTOR = 'script[src*="dashsocial.com/web/js/board-carousel-embed"]';
const SECTION_SELECTOR = ".shopify-section";
const TRACK_SELECTOR = '.dh-widget-container .slick-track[role="list"]';
const SLIDE_SELECTOR = '.dh-widget-container .slick-track > [role="listitem"]';

const observedSections = new WeakSet();

export const patchDashSocialA11y = () => {
    if (document.readyState === "loading") {
        document.addEventListener("DOMContentLoaded", () => patchDashSocialA11y(), { once: true });
        return;
    }

    document.querySelectorAll(EMBED_SCRIPT_SELECTOR).forEach((script) => {
        const section = script.closest(SECTION_SELECTOR);
        if (!section) {
            return;
        }

        dropListRoles(section);

        if (observedSections.has(section)) {
            return;
        }
        observedSections.add(section);

        const observer = new MutationObserver(() => dropListRoles(section));
        observer.observe(section, { childList: true, subtree: true, attributes: true, attributeFilter: ["role"] });
    });
};

const dropListRoles = (section) => {
    section.querySelectorAll(`${TRACK_SELECTOR}, ${SLIDE_SELECTOR}`).forEach((element) => element.removeAttribute("role"));
};
